import { render } from "./v-radio-button.vue?vue&type=template&id=f3f377c0&scoped=true"
import script from "./v-radio-button.vue?vue&type=script&lang=js"
export * from "./v-radio-button.vue?vue&type=script&lang=js"

import "./v-radio-button.vue?vue&type=style&index=0&id=f3f377c0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3f377c0"]])

export default __exports__